/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Add supplier function
 */
export const AddSupplierFunctionBody = zod.object({
  functionId: zod.uuid().describe("Supplier Function identity."),
});

export const AddSupplierFunctionResponse = zod.uuid().describe("Supplier Function identity.");

/**
 * @summary Remove supplier function
 */
export const RemoveSupplierFunctionResponse = zod.void();
